import styled from 'styled-components';

import Loading from 'components/Loading';
import { LoadingBox } from 'components/Loading/styles';
import colors from 'styles/colors';

const LoadingPage = styled.div`
  align-items: center;
  background-color: ${colors.fleetDarkBlue};
  display: flex;
  flex: 1 0 auto;
  justify-content: center;
  height: 100%;
  min-height: inherit;
  width: 100%;

  ${LoadingBox} {
    height: 10em;
    width: 10em;
    border-color: ${colors.fleetElectricYellow};
    border-left-color: transparent;
    border-right-color: transparent;
  }
`;

const ContactlessLoading = () => (
  <LoadingPage>
    <Loading />
  </LoadingPage>
);

export default ContactlessLoading;
